import { actionTypes } from "../actionTypes/actionTypes";
import { IMeetingReducerState } from "../../interfaces/store/IMeetingReducerState";
import { ADMIN } from "../../constants/admin";

const initialState: IMeetingReducerState = {
  meetingId: null,
  fetchTranscribeId: null,
  meetingFormOpen: false,
  meetingTableData: null,
  selectedMeetingData: null,
  meetingFormType: ADMIN.MEETING_FORM_TYPE.CREATE,
  meetingTableLoading: false,
};

const meetingReducer = (
  state: IMeetingReducerState = initialState,
  action: any
) => {
  switch (action.type) {
    case actionTypes.UPDATE_MEETING_ID:
      return {
        ...state,
        meetingId: action.payload,
      };
    case actionTypes.UPDATE_FETCH_TRANS_ID:
      return {
        ...state,
        fetchTranscribeId: action.payload,
      };
    case actionTypes.UPDATE_MEETING_OPEN:
      return {
        ...state,
        meetingFormOpen: action.payload,
      };
    case actionTypes.UPDATE_MEETING_TABLE_DATA:
      return {
        ...state,
        meetingTableData: action.payload,
      };
    case actionTypes.UPDATE_SELECTED_ROW_TABLE_DATA:
      return {
        ...state,
        selectedMeetingData: action.payload,
      };
    case actionTypes.UPDATE_MEETING_FORM_TYPE:
      return {
        ...state,
        meetingFormType: action.payload,
      };
    case actionTypes.UPDATE_MEETING_FORM_LOADING:
      return {
        ...state,
        meetingTableLoading: action.payload,
      };

    default:
      return state;
  }
};

export default meetingReducer;
